import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorage } from '@common/tokens/local-storage.constant';
import { IDTokenStorageKey } from '@common/constants/id-token-key.constants';
import { AppConfig } from '@common/tokens/app-configs.constant';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(LocalStorage);
  const accessToken = storage.getItem(IDTokenStorageKey);
  const appConfig = inject(AppConfig);

  if (req.url.includes(appConfig.msalConfig.api.uri) || req.url.includes('.amazonaws.com')) {
    return next(req.clone());
  }

  return next(
    req.clone({
      setHeaders: {
        ...(!!accessToken && { Authorization: `Bearer ${accessToken}` })
      }
    })
  );
};
